/**
 * Runtime config comes from /config.js (served by the API from its environment), so the
 * same build runs in staging and production. Vite env vars are the local-dev fallback.
 */
interface RuntimeConfig {
  supabaseUrl?: string;
  supabaseAnonKey?: string;
  sentryDsn?: string;
  release?: string;
  smsLogin?: boolean;
  farmaiOrigin?: string;
}

declare global {
  interface Window {
    __FARMOS_CONFIG__?: RuntimeConfig;
  }
}

const rc: RuntimeConfig = (typeof window !== 'undefined' && window.__FARMOS_CONFIG__) || {};

function required(name: string, value: string | undefined): string {
  if (!value) throw new Error(`Missing configuration: ${name}`);
  return value;
}

export const env = {
  supabaseUrl: required('supabaseUrl', rc.supabaseUrl || import.meta.env.VITE_SUPABASE_URL),
  supabaseAnonKey: required(
    'supabaseAnonKey',
    rc.supabaseAnonKey || import.meta.env.VITE_SUPABASE_ANON_KEY,
  ),
  sentryDsn: rc.sentryDsn || (import.meta.env.VITE_SENTRY_DSN as string | undefined),
  release: rc.release || undefined,
  /** SMS OTP login is off by default (it costs money per code); QR login is free. */
  smsLogin: rc.smsLogin ?? import.meta.env.VITE_SMS_LOGIN === 'true',
  /** FarmAI's address; workers' QR codes open it */
  farmaiOrigin:
    rc.farmaiOrigin || (import.meta.env.VITE_FARMAI_ORIGIN as string | undefined) || undefined,
};
